export class Counter {
    count = 0;
    increment = () => {
        ++this.count;
    };
    decrement = () => {
        --this.count;
    };
    value = () => this.count;
}
